<template>
  <BaseDialog
    data-test-id="editAppointments"
    v-bind="$attrs"
    icon="mdi-calendar-clock"
    :title="t('headers.editAppointments')"
    :subTitle="name"
    :max-width="1000"
    :min-height="500"
  >
    <v-row>
      <v-col cols="12">
        <DataTable
          :items-per-page="5"
          :min-table-count="5"
          :search-type="SearchType.Query"
          :show-new="false"
          :table-store-id="TableStoreId.Events"
          :no-data-text="t('text.noEventsScheduled')"
          :delete-message="t('dialogs.delete.warning', { name: t('dialogs.delete.eventName') })"
          :delete-title="t('dialogs.headers.deleteEvent')"
        />
        <EditEvent />
      </v-col>
    </v-row>
  </BaseDialog>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { SearchType } from '@/enums/SearchType'
import { TableStoreId } from '@/enums/TableStoreId'
import type { IAdminsStore } from '@/interfaces/api/IAdminsStore'
import { TableStoreFactory } from '@/stores/db/TableStoreFactory'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseDialog from '../dialogs/BaseDialog.vue'

const { t } = useI18n({ useScope: 'global' })
const store = TableStoreFactory.get(TableStoreId.Admins) as IAdminsStore

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const name = computed(() => {
  if (store.selectedItem) {
    return `${store.selectedItem.firstName} ${store.selectedItem.lastName}`
  }
  return ''
})
// WATCHERS

// LIFECYCLE HOOKS

// FUNCTIONS
</script>
